import React, { useState, useEffect, useMemo } from "react";
import { Table, Badge, Dropdown } from "react-bootstrap";
import {
  getUserList,
  blockUser,
  deleteUser,
  getUserExportList,
  sendNotificationFemale,
  recoverAccountApi,
  hideProfileApi,
  activateAccountApi,
  getUserListInternal,
  sendImageRequestFemale,
  sendImageRequestMember,
  apiFavouriteAllUsers,
} from "../../services/UserServices/UserService";
import Spinner from "../components/Common/Spinner";
import { notifyError, notifyTopRight } from "../components/Common/Toaster";
import Pagination from "../components/Common/Pagination";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import dayjs from "dayjs";
import { RangeDatePicker } from "@y0c/react-datepicker";
import dummmyImg from "../../images/profile/images1.png";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  activeStatusFilterPost,
  serachFilterPost,
} from "../../store/actions/FilterActions";
import * as XLSX from "xlsx";
import { selectConversationNull } from "../../store/actions/SessionActions";
import ConfirmationDeleteAccount from "../components/Modal/ConfirmationDeleteAccount";
import ConfirmModalLock from "../components/Modal/ConfirmModalLock";
import useFilterPage from "../hooks/useFilterPage";

const UsersTableInternal = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const filtersReady = useFilterPage("internal-users");
  const imgBaseURl = process.env.REACT_APP_IMAGE_BASEURL;
  const [loader, setLoader] = useState(false);
  const [users, setUsers] = useState([]);
  const [listLength, setListLength] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [imageForView, setImageForView] = useState("");
  const [view, setView] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    location?.state?.page ? location?.state?.page : 0
  );
  const searchFilter = useSelector((state) => state.filter.filter.search);
  const ageFilter = useSelector((state) => state.filter.filter.age);
  const locationFilter = useSelector((state) => state.filter.filter.location);
  const genderFilter = useSelector((state) => state.filter.filter.gender);
  const statusFilter = useSelector((state) => state.filter.filter.status);
  const formFilledFilter = useSelector(
    (state) => state.filter.filter.formFilled
  );
  const typeFilter = useSelector((state) => state.filter.filter.type);
  const activeStatusFilter = useSelector(
    (state) => state.filter.filter.activeStatus
  );

  const [search, setSearch] = useState(searchFilter);
  const [age, setAge] = useState(ageFilter);
  const [selectedCountry, setSelectedCountry] = useState(locationFilter);
  const [initialFetch, setInitialFetch] = useState(true);
  const [gender, setGender] = useState(genderFilter);
  const [status, setStatus] = useState(statusFilter);
  const [isFormFilled, setIsFormFilled] = useState(formFilledFilter);
  const [signUpType, setSignUpType] = useState(typeFilter);
  const [activeStatus, setActiveStatus] = useState("lastLoginAt");
  const [deleteConfirmationId, setDeleteConfirmationId] = useState("");
  const [newUsers, setNewUsers] = useState([]);
  const limit = 10;
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [exportLoader, setExportLoader] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showActivateAccountConfirm, setShowActivateAccountConfirm] =
    useState(false);
  const [activateAccountConfirmId, setActivateAccountConfirmId] = useState("");
  const [filtersSynced, setFiltersSynced] = useState(false);

  useEffect(() => {
    if (!filtersReady || filtersSynced) return;
    setSearch(searchFilter);
    setAge(ageFilter);
    setSelectedCountry(locationFilter);
    setGender(genderFilter);
    setStatus(statusFilter);
    setIsFormFilled(formFilledFilter);
    setSignUpType(typeFilter);
    setFiltersSynced(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersReady, filtersSynced]);

  function onDateChange(...args) {
    const todayStr = moment().format("YYYY-MM-DD");
    const startRaw = args[0] ? moment(args[0]).format("YYYY-MM-DD") : null;
    const endRaw = args[1] ? moment(args[1]).format("YYYY-MM-DD") : null;
    setStartDate(
      startRaw ? (startRaw > todayStr ? todayStr : startRaw) : null
    );
    setEndDate(
      endRaw ? (endRaw > todayStr ? todayStr : endRaw) : null
    );
  }
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  const headers = [
    { label: "CONTACT ID", key: "_id" },
    { label: "EMAIL", key: "email" },
    { label: "FIRST NAME", key: "name" },
    { label: "LAST NAME", key: "" },
    { label: "SMS", key: "phoneNumber" },
  ];
  const getTableData = async () => {
    setLoader(true);
    try {
      const response = await getUserListInternal(
        currentPage,
        limit,
        search,
        activeStatus,
        startDate,
        endDate
      );
      setUsers(response.data.data.users);
      const total = response.data.data.count;
      setPageCount(Math.ceil(total / limit));
      setListLength(total);
      setLoader(false);
      setInitialFetch(false);
    } catch (error) {
      console.log(error, "error");
      setLoader(false);
    }
  };

  const getTableDataSearch = async () => {
    setCurrentPage(0);
    getTableData();
  };

  function onReset() {
    // setDateRangePickerKey((prev) => prev + 1);
    setStartDate(null);
    setEndDate(null);
  }
  const onDelete = async (id) => {
    setLoader(true);
    try {
      const response = await deleteUser(deleteConfirmationId);
      notifyTopRight(response.data?.message);
      setLoader(false);
      getTableData();
      setShowDeleteModal(false);
      setDeleteConfirmationId("");
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  const onAction = async (id) => {
    setLoader(true);
    try {
      const response = await blockUser(id);
      notifyTopRight(response.data?.message);
      getTableData();
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  useEffect(() => {
    if (!filtersSynced) return;
    getTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    filtersSynced,
    currentPage,
    gender,
    selectedCountry,
    status,
    isFormFilled,
    signUpType,
    activeStatus,
    startDate,
    endDate,
  ]);

  let timeoutId;
  // Define a helper function for debouncing
  const debounce = (func, delay) => {
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const debouncedHandleFetch = debounce(getTableData, 500);
  useEffect(() => {
    if (initialFetch === false) {
      setCurrentPage(0);
      debouncedHandleFetch();
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, []);

  const sendNotification = async (id, type) => {
    try {
      const response = await sendNotificationFemale(id, type);
      notifyTopRight(response.data?.message);
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  const activateAccount = async (id) => {
    setLoader(true);
    try {
      const response = await activateAccountApi(id);
      notifyTopRight(response.data?.message);
      getTableData();
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  const onActivateAccountClick = (id, isPremium, gender) => {
    if (isPremium && gender === "male") {
      setActivateAccountConfirmId(id);
      setShowActivateAccountConfirm(true);
      return;
    }
    activateAccount(id);
  };

  const onConfirmActivateAccount = async () => {
    if (!activateAccountConfirmId) return;
    await activateAccount(activateAccountConfirmId);
    setShowActivateAccountConfirm(false);
    setActivateAccountConfirmId("");
  };

  const hideProfile = async (id) => {
    setLoader(true);
    try {
      const response = await hideProfileApi(id);
      notifyTopRight(response.data?.message);
      getTableData();
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  const recoveAccount = async (id) => {
    try {
      const response = await recoverAccountApi(id);
      getTableData();
      notifyTopRight(response.data?.message);
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  function formatTimestamp(timestamp) {
    const isSeconds = String(timestamp).length === 10;
    const timestampInMilliseconds = isSeconds ? timestamp * 1000 : timestamp;
    return moment(timestampInMilliseconds).format("DD-MM-YYYY, h:mm A");
  }

  const isSameDayAsToday = (timestamp) => {
    if (!timestamp) return false;
    const raw = Number(timestamp);
    if (!Number.isFinite(raw)) return false;
    const tsMs = String(raw).length === 10 ? raw * 1000 : raw;
    return moment(tsMs).isSame(moment(), "day");
  };


  const sendImageRequest = async (id) => {
    try {
      const response = await sendImageRequestFemale(id);
      notifyTopRight(response.data?.message);
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  const sendImageRequestToMember = async (id) => {
    try {
      const response = await sendImageRequestMember(id);
      notifyTopRight(response.data?.message);
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  const favouriteAllUsers = async (id) => {
    try {
      const response = await apiFavouriteAllUsers(id);
      notifyTopRight(response.data?.message);
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  return loader ? (
    <Spinner />
  ) : (
    <>
      <div className="">
        {/* ======================= ROW 1: Search / Age / Date / Reset - All Screens ======================= */}
        <div className="row g-3 align-items-end mb-3">
          {/* Search Input */}
          <div className="col-12 col-md-6 col-lg-4 d-flex gap-2">
            <input
              type="search"
              className="form-control py-3"
              placeholder="Search"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                dispatch(serachFilterPost(e.target.value));
              }}
              onKeyDown={(e) => e.key === "Enter" && getTableDataSearch()}
            />
            <button
              className="btn btn-primary py-3 px-3"
              onClick={getTableDataSearch}
            >
              <i className="fa fa-search" />
            </button>
          </div>
          <div className="col-12 col-md-6 col-lg-3">
            <label className="form-label fw-semibold">Sort by</label>
            <select
              className="form-control py-2"
              value={activeStatus}
              onChange={(e) => {
                setActiveStatus(e.target.value);
                dispatch(activeStatusFilterPost(e.target.value));
              }}
            >
              <option value="completedAt">Completed At</option>
              <option value="createdAt">Created At</option>
              <option value="lastActive">Last Active</option>
              <option value="lastLoginAt">Last Login</option>
            </select>
          </div>

        </div>
      </div>

      <Table responsive>
        <thead style={{ color: "black" }}>
          <tr>
            <th>
              <strong>Image</strong>
            </th>
            <th>
              <strong>NAME</strong>
            </th>
            <th>
              <strong>EMAIL</strong>
            </th>
            <th>
              <strong>Gender</strong>
            </th>
            <th>
              <strong>PHONE NUMBER</strong>
            </th>
            <th>
              <strong>Temp Phone</strong>
            </th>
            {/* <th>
              <strong>Referral Code</strong>
            </th>
            <th>
              <strong>Redeemed by</strong>
            </th> */}
            <th>
              <strong>STATUS</strong>
            </th>
            <th>
              <strong>Completed at</strong>
            </th>
            <th>
              <strong>Device</strong>
            </th>
            <th>
              <strong>Last Active</strong>
            </th>
            <th>
              <strong>Last Login</strong>
            </th>
            <th>
              <strong>Hide</strong>
            </th>
            <th>
              <strong>ACTION</strong>
            </th>
          </tr>
        </thead>
        <tbody>
          {users?.map((item, i) => (
            <tr
              key={i}
              onClick={() =>
                window.open(`/user-details-internal?data=${item?._id}`, "_blank")
              }
              className="pointer"
              style={{
                cursor: "pointer",
                fontSize: "14px",
                color: "#111827",
              }}
            >
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <img
                  src={
                    item?.images[0]?.url
                      ? imgBaseURl + item?.images[0]?.url
                      : dummmyImg
                  }
                  width={100}
                  height={80}
                  alt=""
                  style={{ objectFit: "cover", borderRadius: 8 }}
                  onClick={() => {
                    setImageForView(imgBaseURl + item?.images[0]?.url);
                    setView(true);
                  }}
                />
              </td>
              <td>{item?.name}</td>
              <td>{item?.email}</td>
              <td>
                {item?.gender &&
                  item?.gender?.charAt(0).toUpperCase() +
                  item?.gender?.slice(1)}
              </td>
              <td>
                {item.countryCode && "+" + item.countryCode} {item?.phoneNumber}
              </td>
              <td> {item?.tempDetails?.countryCode ? "+" + item?.tempDetails?.countryCode : ""} {item?.tempDetails?.phoneNumber}</td>
              {/* <td>{item?.myReferralCode}</td> */}

              {/* <td
                className={` ${item.referralCount > 0 ? "pointer" : ""}`}
                onClick={(event) => {
                  event.stopPropagation();

                  if (item.referralCount > 0) {
                    navigate("/redeemed-by", {
                      state: { id: item?.referralId },
                    });
                  }
                }}
              >
                {item.referralCount}
              </td> */}
              <td>
                {(() => {
                  if (status !== "all") {
                    if (status === "adminDeleted" && item?.isDeletedByAdmin) {
                      return (
                        <Badge bg="" className="badge-secondary">
                          Deleted by Admin
                        </Badge>
                      );
                    }
                    if (status === "delete" && item?.isDeleted) {
                      return (
                        <Badge bg="" className="badge-secondary">
                          Deleted
                        </Badge>
                      );
                    }
                    if (status === "disable" && item?.isBlocked) {
                      return (
                        <Badge bg="" className="badge-danger">
                          Disabled
                        </Badge>
                      );
                    }
                    if (status === "deactivate" && item?.isDeactivated) {
                      return (
                        <Badge bg="" className="badge-warning">
                          Deactivated
                        </Badge>
                      );
                    }
                    if (
                      status === "enable" &&
                      !item?.isDeletedByAdmin &&
                      !item?.isDeleted &&
                      !item?.isDeactivated &&
                      !item?.isBlocked
                    ) {
                      return (
                        <Badge bg="" className="badge-success">
                          Enabled
                        </Badge>
                      );
                    }
                  }

                  if (item?.isDeletedByAdmin) {
                    return (
                      <Badge bg="" className="badge-secondary">
                        Deleted by Admin
                      </Badge>
                    );
                  }
                  if (item?.isDeleted) {
                    return (
                      <Badge bg="" className="badge-secondary">
                        Deleted
                      </Badge>
                    );
                  }
                  if (item?.isBlocked) {
                    return (
                      <Badge bg="" className="badge-danger">
                        Disabled
                      </Badge>
                    );
                  }
                  if (item?.isDeactivated) {
                    return (
                      <Badge bg="" className="badge-warning">
                        Deactivated
                      </Badge>
                    );
                  }
                  return (
                    <Badge bg="" className="badge-success">
                      Enabled
                    </Badge>
                  );
                })()}
              </td>
              <td>{item?.completedAt ? moment(item?.completedAt).format("MMM Do YYYY, h:mm A") : ""}</td>
              <td>{item?.deviceType ? item?.deviceType.toUpperCase() : ""}</td>
              <td>{formatTimestamp(item?.lastApiCall)}</td>
              <td>
                {item?.lastLoginAt
                  ? moment(item.lastLoginAt).format("DD-MM-YYYY, h:mm A")
                  : ""}
              </td>
              <td>
                <Badge bg="" className="badge-danger">
                  {item?.hideProfile && "Hide"}
                </Badge>
              </td>
              <td
                onClick={(event) => {
                  event.stopPropagation();
                }}
              >
                {!item?.isDeleted ? (
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="info light"
                      className="light sharp btn btn-info i-false"
                    >
                      {svg1}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {item?.gender === "female" && (
                        <Dropdown.Item
                          disabled={!isSameDayAsToday(item?.lastApiCall) || item?.isDeactivated}
                          onClick={() => {
                            if (!isSameDayAsToday(item?.lastApiCall) || item?.isDeactivated) return;
                            sendNotification(item._id, "all");
                          }}
                          style={{
                            color:
                              !isSameDayAsToday(item?.lastApiCall) ||
                              item?.isDeactivated
                                ? "#9aa0a6"
                                : item?.privacy?.showViewedProfile
                                  ? "green"
                                  : "red",
                          }}
                        >
                          Send Notification to all
                        </Dropdown.Item>
                      )}
                      {item?.gender === "male" && (
                        <Dropdown.Item onClick={() => hideProfile(item._id)}>
                          {item?.hideProfile ? "Unhide" : "Hide"} Profile
                        </Dropdown.Item>
                      )}
                      <Dropdown.Item
                        onClick={() => {
                          navigate("/chat", {
                            state: {
                              data: item?._id,
                              selectedTab: "users",
                              userName: item?.name,
                              search: search,
                              page: currentPage,
                              gender: item?.gender,
                              type: "table",
                              userType: "user",
                            },
                          });
                          dispatch(selectConversationNull(null));
                        }}
                      >
                        Chat
                      </Dropdown.Item>
                      {item?.gender === "female" && (
                        <Dropdown.Item
                          disabled={!isSameDayAsToday(item?.lastApiCall) || item?.isDeactivated}
                          onClick={() => {
                            if (!isSameDayAsToday(item?.lastApiCall) || item?.isDeactivated) return;
                            sendNotification(item._id, "premium");
                          }}
                          style={{
                            color:
                              !isSameDayAsToday(item?.lastApiCall) ||
                              item?.isDeactivated
                                ? "#9aa0a6"
                                : item?.privacy?.showViewedProfile
                                  ? "green"
                                  : "red",
                          }}
                        >
                          Send Notification to member
                        </Dropdown.Item>
                      )}
                      {item?.gender === "female" && (
                        <Dropdown.Item
                          disabled={!isSameDayAsToday(item?.lastApiCall) || item?.isDeactivated}
                          onClick={() => {
                            if (!isSameDayAsToday(item?.lastApiCall) || item?.isDeactivated) return;
                            sendNotification(item._id, "nonPremium");
                          }}
                          style={{
                            color:
                              !isSameDayAsToday(item?.lastApiCall) ||
                              item?.isDeactivated
                                ? "#9aa0a6"
                                : item?.privacy?.showViewedProfile
                                  ? "green"
                                  : "red",
                          }}
                        >
                          Send Notification to non member
                        </Dropdown.Item>
                      )}
                      {item?.isDeactivated && (
                        <Dropdown.Item
                          onClick={() => {
                            onActivateAccountClick(item._id, item?.isPremium, item?.gender);
                          }}
                        >
                          Activate Account
                        </Dropdown.Item>
                      )}
                      {item?.gender === "female" && (
                        <Dropdown.Item
                          onClick={() => sendImageRequest(item._id)}
                        >
                          Send Image Access Requests (Non-Members)
                        </Dropdown.Item>
                      )}
                      {item?.gender === "female" && (
                        <Dropdown.Item
                          onClick={() => sendImageRequestToMember(item._id)}
                        >
                          Send Image Access Requests (Member)
                        </Dropdown.Item>
                      )}
                      {item?.gender === "female" && (
                        <Dropdown.Item
                          onClick={() => favouriteAllUsers(item._id)}
                          style={{color: !isSameDayAsToday(item?.lastApiCall) || item?.isDeactivated
                            ? "#9aa0a6"
                            : item?.privacy?.showFavouriteProfile
                              ? "green"
                              : "red",}}
                          disabled={!isSameDayAsToday(item?.lastApiCall) || item?.isDeactivated}
                        >
                          Send Favourite Notification to All Male Users
                        </Dropdown.Item>
                      )}

                    </Dropdown.Menu>
                  </Dropdown>
                ) : (
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="info light"
                      className="light sharp btn btn-info i-false"
                    >
                      {svg1}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => recoveAccount(item._id)}>
                        Recover Account
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {users?.length === 0 && !loader && (
        <div className="justify-content-center d-flex my-5">
          Sorry, Data Not Found!
        </div>
      )}
      {users?.length !== 0 && (
        <div className="card-footer clearfix">
          <div className="d-block d-sm-flex justify-content-between align-items-center">
            <div className="dataTables_info">
              Showing {currentPage * limit + 1} to{" "}
              {listLength > (currentPage + 1) * limit
                ? (currentPage + 1) * limit
                : listLength}{" "}
              of {listLength} entries
            </div>
            <Pagination
              pageCount={pageCount}
              pageValue={currentPage}
              setPage={setCurrentPage}
            />
          </div>
        </div>
      )}
      <ConfirmationDeleteAccount
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={onDelete}
      />
      {showActivateAccountConfirm && (
        <ConfirmModalLock
          open={showActivateAccountConfirm}
          title={"Activate Account"}
          description={
            "This user is a premium member. Are you sure you want to activate the account?"
          }
          confirmText={"Activate"}
          onCancel={() => {
            setShowActivateAccountConfirm(false);
            setActivateAccountConfirmId("");
          }}
          onConfirm={onConfirmActivateAccount}
        />
      )}
    </>
  );
};

export default UsersTableInternal;
